import axios from 'axios'
import {UposlenikModel, Option} from '../models/UposlenikModel'
import {getAuth} from '../modules/auth'
import {JedinicaMjere} from '../models/JedinicaMjere'

const API_URL = process.env.REACT_APP_API_URL
const DROPDOWN_API = `${API_URL}/JmDropdown`
const API = `${API_URL}/jedinicaMjere`
const auth: UposlenikModel = getAuth()!

const headers = {Accept: 'application/json', Authorization: auth?.access_token ?? ''}

// Get request for Jm Dropdown data.
export async function getJmDropdown() {
  try {
    return await axios.get<Array<Option>>(DROPDOWN_API, {headers: headers})
  } catch (error) {
    console.error('Error fetching Jm Dropdown data:', error)
    throw error // Re-throw the error so it can be handled by the caller if necessary
  }
}
// Get request for Vrsta Materijala dropdown data.
export async function getAllJedinicaMjere(pageNo: number, perPage: number) {
  const params = {per_page: perPage, page: pageNo}
  return await axios.get<Array<JedinicaMjere>>(API, {headers: headers, params: params})
}

export async function saveJedinicaMjere(Data: any) {
  try {
    const response = await axios.post(API, Data, {headers: headers})
    if (response.data.error === 0) {
      return response.data
    } else {
      // Handle any other type of response structure or errors returned from the server here
      throw new Error(response.data.message || 'Failed to fetch.')
    }
  } catch (error) {
    console.error('Error fetching data:', error)
    throw error // Re-throw the error so it can be handled by the caller if necessary
  }
}

export async function fetchJedinicaMjere(Id: number): Promise<Partial<JedinicaMjere>> {
  try {
    const response = await axios.get(`${API}/${Id}`)
    if (response.data && response.data.error === 0) {
      return response.data.data
    } else {
      // Handle any other type of response structure or errors returned from the server here
      throw new Error(response.data.message || 'Failed to fetch.')
    }
  } catch (error) {
    console.error('Error fetching data:', error)
    throw error // Re-throw the error so it can be handled by the caller if necessary
  }
}

export async function updateJedinicaMjere(Data: any, id: number) {
  try {
    const response = await axios.post(`${API}/${id}?_method=PATCH`, Data, {headers: headers})
    if (response.data.error === 0) {
      return response.data
    } else {
      // Handle any other type of response structure or errors returned from the server here
      throw new Error(response.data.message || 'Failed to fetch.')
    }
  } catch (error) {
    console.error('Error fetching data:', error)
    throw error // Re-throw the error so it can be handled by the caller if necessary
  }
}

export async function deleteJedinicaMjere(Id: number) {
  try {
    const response = await axios.delete(`${API}/${Id}`, {headers: headers})
    if (response.data) {
      return response
    } else {
      // Handle any other type of response structure or errors returned from the server here
      throw new Error(response.data.message || 'Failed to delete.')
    }
  } catch (error) {
    console.error('Error deleting data:', error)
    throw error // Re-throw the error so it can be handled by the caller if necessary
  }
}
